import React, { FC, useEffect } from 'react'
import { LoanOfficerDisplayInfo } from '@mortgage-pos/types'
import { formatPhoneNumber, unformatPhoneNumber } from '@mortgage-pos/utils'
import PhoneIconGreen from '@mortgage-pos/ui/assets/PhoneIconGreen.svg'
import EmailIconGreen from '@mortgage-pos/ui/assets/EmailIconGreen.svg'
import Caret from '@mortgage-pos/ui/assets/Caret.svg'
import { customTextMap } from '../utils/customizationHelpers'

interface Props {
  loanOfficer: LoanOfficerDisplayInfo
  handleGoBackToRatesClick: () => void
}

const LoanOfficerPricing: FC<Props> = ({
  loanOfficer,
  handleGoBackToRatesClick,
}) => {
  const phoneNumber = loanOfficer?.phone
    ? formatPhoneNumber(loanOfficer.phone)
    : ''

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [])

  return (
    <aside className="lo-pricing__container">
      <div
        className="lo-pricing__back-to-rates"
        onClick={handleGoBackToRatesClick}
      >
        <img src={Caret} alt="back arrow" className="lo-pricing__back-icon" />
        Go back to rates
      </div>
      <div className="lo-pricing__heading-container">
        <h1 className="lo-pricing__heading">
          Get expert advice on which rate is right for you.
        </h1>
        <h2 className="lo-pricing__sub-heading">
          We can connect you with a mortgage expert to answer your questions and
          guide you through your mortgage application.
        </h2>
      </div>
      <div className="lo-pricing__cards">
        <div className="lo-pricing__cards-lo">
          <img
            src={loanOfficer?.headshot}
            alt={`${loanOfficer?.name} headshot`}
            className="lo-pricing__headshot"
          />
          <h3 className="lo-pricing__name">
            Hi, I'm {loanOfficer?.name}, your assigned mortgage expert.
          </h3>
          <p className="lo-pricing__description">
            I’ll be glad to assist you in finding the perfect option for you.
            Give me a call or send me an email and I’ll get back to you within
            the next 24 hours.
          </p>
          <a
            className="lo-pricing__email"
            href={`mailto: ${loanOfficer?.email}`}
          >
            <img
              src={EmailIconGreen}
              alt="Email Icon"
              className="lo-pricing__email-icon"
            />
            {loanOfficer?.email}
          </a>
          <a
            className="lo-pricing__phone"
            href={`tel:+1${unformatPhoneNumber(loanOfficer?.phone)}`}
          >
            <img
              src={PhoneIconGreen}
              alt="Phone Icon"
              className="lo-pricing__phone-icon"
            />
            {phoneNumber}
          </a>
        </div>
        <div className="lo-pricing__cards-steps">
          <h3 className="lo-pricing__steps-heading">Your next steps:</h3>
          <div className="lo-pricing__steps-icon">1</div>
          <p className="lo-pricing__steps-description">
            Check your inbox for an email from{' '}
            {customTextMap('fullSagePartnerName')} to create your borrower
            portal account. Your borrower portal is where we need you to upload
            your documents.
          </p>
          <div className="lo-pricing__steps-icon">2</div>
          <p className="lo-pricing__steps-description">
            Talk to your mortgage expert now or they will be in contact with you
            in the next 24 hours.
          </p>
        </div>
      </div>
    </aside>
  )
}

export default LoanOfficerPricing
